'use client'

import { useEffect, useState } from 'react'
import { usePathname } from 'next/navigation'
import { EventSurveyCard } from './event-survey-card'

export const EventSurveyLayout = ({ children }: { children: React.ReactNode }) => {
  const [showSurvey, setShowSurvey] = useState(false)
  const pathname = usePathname()
  
  // Don't show on coming-soon page
  const isComingSoonPage = pathname === '/coming-soon'

  useEffect(() => {
    if (isComingSoonPage) return

    // Check if survey was dismissed or option selected in this session
    const surveyDismissed = sessionStorage.getItem('socialloop_survey_dismissed') === 'true'
    const optionSelected = sessionStorage.getItem('socialloop_option_selected') === 'true'
    
    if (!surveyDismissed && !optionSelected) {
      const timer = setTimeout(() => {
        setShowSurvey(true)
      }, 45000) // Show after 45 seconds

      return () => clearTimeout(timer)
    }
  }, [isComingSoonPage])

  const handleSurveyDismiss = () => {
    setShowSurvey(false)
    // Store dismissal in sessionStorage so it won't show again until page reload/new session
    sessionStorage.setItem('socialloop_survey_dismissed', 'true')
  }

  return (
    <>
      {children}
      
      {/* Event Survey Popup */}
      {showSurvey && !isComingSoonPage && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
          {/* Backdrop */}
          <div 
            className="absolute inset-0 bg-black/20 backdrop-blur-sm" 
            onClick={handleSurveyDismiss}
          />
          
          {/* Survey Card */}
          <div className="relative z-10">
            <EventSurveyCard />
            
            {/* Close Button */}
            <button
              onClick={handleSurveyDismiss}
              className="absolute -top-3 -right-3 w-8 h-8 bg-red-400 border-3 border-black rounded-full font-black text-black hover:bg-red-300 transform rotate-12 hover:rotate-0 transition-all duration-200 shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] hover:shadow-[2px_2px_0px_0px_rgba(0,0,0,1)] flex items-center justify-center"
            >
              ×
            </button>
          </div>
        </div>
      )}
    </>
  )
}